import { getRefreshPinToken } from '@/helpers/fetcher/token';
import { defineHeaders } from '@/helpers/fetcher/headers';
import { Fetcher } from '@ajaibid/utils';

/**
 * @typedef {object} v7RefreshPinToken
 * @property {string} access_token
 * @property {string} refresh_token
 */

/**
 * @returns {Promise<v7RefreshPinToken>}
 */
export async function v7RefreshPinToken() {
  const headers = defineHeaders();
  const res = await Fetcher().post(
    `${process.env.API_URL}v7/refresh/pin`,
    {},
    { headers: { ...headers, Authorization: `jwt ${getRefreshPinToken()}` } }
  );

  return res.data;
}
